import * as React from "react";
const SvgTag = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g clipPath="url(#tag_svg__a)">
      <path
        fill="currentColor"
        d="M4.667 5a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.057 1.39c-.25-.25-.589-.39-.942-.39H2.333A1.333 1.333 0 0 0 1 2.333v4.782c0 .353.14.692.39.942l5.803 5.803a1.617 1.617 0 0 0 2.28 0l4.387-4.387a1.617 1.617 0 0 0 0-2.28z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.667 5a.333.333 0 1 0 0-.667.333.333 0 0 0 0 .667"
      />
    </g>
    <defs>
      <clipPath id="tag_svg__a">
        <path fill="#fff" d="M0 0h15.33v15.33H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTag;
